import React from "react";
import { FaTimes } from "react-icons/fa";

/**
 * Reusable Modal Component
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the modal is visible
 * @param {Function} props.onClose - Function to call when closing the modal
 * @param {string} props.title - Modal title
 * @param {React.ReactNode} props.children - Modal body content
 * @param {React.ReactNode} props.footer - Modal footer content (optional)
 * @param {string} props.maxWidth - Tailwind max-width class (default: max-w-xl)
 */
const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  footer, 
  maxWidth = "max-w-xl",
  showCloseButton = true
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = () => {
    if (showCloseButton) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-[200] overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black/40 backdrop-blur-[2px] transition-opacity" 
          onClick={handleBackdropClick}
        ></div>

        {/* Modal Container */}
        <div className={`relative bg-white rounded-xl shadow-2xl w-full ${maxWidth} overflow-hidden transform transition-all`}>
          {/* Header */}
          <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between">
            <h3 className="text-xl font-semibold text-gray-900 leading-none">
              {title}
            </h3>
            {showCloseButton && (
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-lg hover:bg-gray-50 drop-shadow-sm"
              >
                <FaTimes size={18} />
              </button>
            )}
          </div>

          {/* Body */}
          <div className="px-6">
            {children}
          </div>

          {/* Footer */}
          {footer && (
            <div className="px-6 py-2 bg-gray-50/50 border-t border-gray-100 flex justify-end gap-3">
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
